import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

const SECRET_KEY = '3y^#7*H8w@Kz!pL9mD&4t$FqZ8^QbR#2sT*jV5zN#1x'; // Use a strong secret key

const encryptValue = (value) => {
    const valueToEncrypt = typeof value === 'string' ? value : String(value);
    return CryptoJS.AES.encrypt(valueToEncrypt, SECRET_KEY).toString();
};

const decryptValue = (encryptedValue) => {
    const bytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
};


export function setCookieWithExpiration(name, value, minutes){
    try {
        const encryptedValue = encryptValue(value);
        Cookies.set(name, encryptedValue, {expires: minutes, secure: true, sameSite: 'Strict'});
        //Cookies.set(name, encryptedValue, {expires: minutes});
    } catch (error) {
        console.error(`Error setting cookie ${name}:`, error);
    }
}

export function isCookieValid(name){
    try {
        return Cookies.get(name) !== undefined;
    } catch (error) {
        console.error(`Error reading cookie ${name}:`, error);
        return false;
    }
}

export function deleteCookie(name){
    try {
        Cookies.remove(name);
    } catch (error) {
        console.error(`Error deleting cookie ${name}:`, error);
    }
}
export function getCookie(name){
    try {
        const encryptedValue = Cookies.get(name);
        if (encryptedValue) {
            return decryptValue(encryptedValue);
        }
        return null;
    } catch (error) {
        // Value is unreadable (blocked cookie access) or undecryptable (corrupted/stale
        // ciphertext, e.g. from an older app version) - clear it so it doesn't keep
        // breaking every subsequent load, and fall back to a logged-out state.
        console.error(`Error reading/decrypting cookie ${name}, clearing it:`, error);
        deleteCookie(name);
        return null;
    }
}

export function updateCookieExpiration(name, options){
    try {
        const currentValue = Cookies.get(name);
        if(currentValue){
            Cookies.set(name, currentValue, options);
        }
    } catch (error) {
        console.error(`Error updating expiration for cookie ${name}:`, error);
    }
}

export function updateCookieValue(name, newValue, options){
    try {
        const currentValue = Cookies.get(name);
        if(currentValue){
            const encryptedValue = encryptValue(newValue);
            Cookies.set(name, encryptedValue, options);
        }
    } catch (error) {
        console.error(`Error updating cookie ${name}:`, error);
    }
}